const stats = [
  { value: "125 GW", label: "Connection Queue Tracked" },
  { value: "6000+", label: "Projects Analyzed" },
  { value: "14", label: "DNO Regions Covered" },
  { value: "99%", label: "Data Accuracy" },
]

export default function StatsSection() {
  return (
    <section className="relative z-10 -mt-20 mx-auto max-w-5xl px-6 sm:px-10">
      <div className="grid grid-cols-2 md:grid-cols-4 gap-px bg-[#DDDDDD] shadow-2xl">
        {stats.map((stat, index) => (
          <div key={index} className="bg-background px-8 py-10 flex flex-col">
            <div className="text-4xl sm:text-5xl font-black text-black tracking-tight leading-none mb-3">
              {stat.value}
            </div>
            <div className="text-[11px] font-semibold text-black/50 uppercase tracking-widest">
              {stat.label}
            </div>
          </div>
        ))}
      </div>
    </section>
  )
}
